<template>
    <v-list
        nav
        dense
        :expand="true"
    >
        <template v-if="path.match('/dashboard') || path.match('/applying') || path.match('/verification') 
                        || path.match('/recieved') || path.match('/draft') || path.match('/conclusion') 
                        || path.match('/rejected') || path.match('/document-management')
                        || path.match('/agreement/all-list')">
            <v-list-item>
                <v-btn
                    block
                    color="red"
                    class="white--text"
                    href="/documents/agreements/new"
                >
                    新規書類の送信
                </v-btn>
            </v-list-item>
            <hr>
            <v-list-item v-if="navi.plan == true" link href="/documents/agreement/all-list" v-bind:class="{ act: path.match(/\/agreement\/all-list$/) }">
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-email-send</v-icon>
                </v-list-item-icon>
                <v-list-item-title>すべての送受信</v-list-item-title>
            </v-list-item>

            <v-list-group
                :value="true"
                color="rgba(0,0,0,.87)"
            >
                <template v-slot:activator>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-email-send</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>あなたの送受信</v-list-item-title>
                </template>
                <v-list-item link href="/documents/applying" v-bind:class="{ act: path.match(/\/applying$/) }">
                    <v-list-item-icon class="mx-0"></v-list-item-icon>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-email-send</v-icon>
                    </v-list-item-icon>
                    <template v-if="navi.numbers.applying_error == 0">
                        <v-list-item-title>承認待ち（{{ navi.numbers.applying }}）</v-list-item-title>
                    </template>
                    <template v-else>
                        <v-list-item-title>承認待ち（{{ navi.numbers.applying }}）<br><v-icon class="alert">mdi-alert-circle-outline</v-icon><span class="alert">{{ navi.numbers.applying_error > 0? '送信エラー' + navi.numbers.applying_error + '件' : '' }}</span></v-list-item-title>
                    </template>
                </v-list-item>
                <v-list-item link href="/documents/verification"  v-bind:class="{ act: path.match(/\/verification$/) }">
                    <v-list-item-icon class="mx-0"></v-list-item-icon>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-email-edit</v-icon>
                    </v-list-item-icon>
                    <template v-if="navi.numbers.verification_error == 0">
                        <v-list-item-title>署名待ち（{{ navi.numbers.verification }}）</v-list-item-title>
                    </template>
                    <template v-else>
                        <v-list-item-title>署名待ち（{{ navi.numbers.verification }}）<br><v-icon class="alert">mdi-alert-circle-outline</v-icon><span class="alert">{{ navi.numbers.verification_error > 0? '送信エラー' + navi.numbers.verification_error + '件' : '' }}</span></v-list-item-title>
                    </template>
                </v-list-item>
                <v-list-item link href="/documents/recieved"  v-bind:class="{ act: path.match(/\/recieved$/) }">
                    <v-list-item-icon class="mx-0"></v-list-item-icon>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-email-receive-outline</v-icon>
                    </v-list-item-icon>
                    <template v-if="navi.numbers.recieved_error == 0">
                        <v-list-item-title>要確認（{{ navi.numbers.recieved }}）</v-list-item-title>
                    </template>
                    <template v-else>
                        <v-list-item-title>要確認（{{ navi.numbers.recieved }}）<br><v-icon class="alert">mdi-alert-circle-outline</v-icon><span class="alert">{{ navi.numbers.recieved_error > 0? '送信エラー' + navi.numbers.recieved_error + '件' : '' }}</span></v-list-item-title>
                    </template>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item link href="/documents/draft"  v-bind:class="{ act: path.match(/\/draft$/) }">
                    <v-list-item-icon class="mx-0"></v-list-item-icon>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-file-edit</v-icon>
                    </v-list-item-icon>
                    <template v-if="navi.numbers.draft_error == 0">
                        <v-list-item-title>下書き（{{ navi.numbers.draft }}）</v-list-item-title>
                    </template>
                    <template v-else>
                        <v-list-item-title>下書き（{{ navi.numbers.draft }}）<br><v-icon class="alert">mdi-alert-circle-outline</v-icon><span class="alert">{{ navi.numbers.draft_error > 0? '送信エラー' + navi.numbers.draft_error + '件' : '' }}</span></v-list-item-title>
                    </template>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item link href="/documents/conclusion"  v-bind:class="{ act: path.match(/\/conclusion$/) }">
                    <v-list-item-icon class="mx-0"></v-list-item-icon>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-check-circle-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>締結済み</v-list-item-title>
                </v-list-item>
                <v-list-item link href="/documents/rejected"  v-bind:class="{ act: path.match(/\/rejected$/) }">
                    <v-list-item-icon class="mx-0"></v-list-item-icon>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-close-circle-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>却下</v-list-item-title>
                </v-list-item>
            </v-list-group>

            <hr>

            <v-list-group
                :value="path.match('document-management')"
                color="rgba(0,0,0,.87)"
            >
                <template v-slot:activator>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-folder</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>文書管理</v-list-item-title>
                </template>
                <v-list-item link href="/documents/document-management/all-document"  v-bind:class="{ act: path.match(/\/document-management\/all-document$/) }">
                    <v-list-item-icon class="mx-0"></v-list-item-icon>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-folder</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>すべての書類</v-list-item-title>
                </v-list-item>
                <v-list-item  v-if="navi.plan == true" link href="/documents/document-management" v-bind:class="{ act: path.match(/\/document-management$/) }">
                    <v-list-item-icon class="mx-0"></v-list-item-icon>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-folder-multiple</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>共有キャビネット</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="user.role == 1" link href="/documents/document-management/user-defined" v-bind:class="{ act: path.match(/\/document-management\/user-defined$/) }">
                    <v-list-item-icon class="mx-0"></v-list-item-icon>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-cog</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>ユーザー定義項目</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="navi.plan == true && user.role == 1" link href="/documents/document-management/template" v-bind:class="{ act: path.match(/\/document-management\/template$/) }">
                    <v-list-item-icon class="mx-0"></v-list-item-icon>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-cog</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>テンプレート管理</v-list-item-title>
                </v-list-item>
            </v-list-group>
            <hr>  
            <v-list-item　link href="/documents/notifications">
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-cog</v-icon>
                </v-list-item-icon>
                <v-list-item-title>管理</v-list-item-title>
            </v-list-item>
        </template>

        <!-- 管理メニュー -->
        <template v-else>
            <v-list-item>
                <v-btn
                    block
                    color="blue"
                    class="white--text"
                    href="/documents/dashboard"
                >
                    ダッシュボードに戻る
                </v-btn>
            </v-list-item>
            <template v-if="user.role == 1"> <!-- 管理者 -->
             <hr>
               <v-list-item link href="/documents/plans" v-if="path.match('/plans')" class="act">
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-format-list-text</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>利用プラン変更</v-list-item-title>
                </v-list-item>
                <v-list-item link href="/documents/plans" v-else>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-format-list-text</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>利用プラン変更</v-list-item-title>
                </v-list-item>
            </template>

            <template v-if="user.role == 1"> <!-- 管理者 -->
                <v-list-item link href="/documents/companies" v-if="path.match('/companies')" class="act">
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-office-building</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>企業情報更新</v-list-item-title>
                </v-list-item>
                <v-list-item link href="/documents/companies" v-else>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-office-building</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>企業情報更新</v-list-item-title>
                </v-list-item>
            </template>
                        
            <template v-if="navi.plan == true && user.role == 1"> <!-- 管理者 -->
                <v-list-item link href="/documents/invoices" v-if="path.match('/invoices')" class="act">
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-credit-card</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>支払方法更新</v-list-item-title>
                </v-list-item>
                <v-list-item link href="/documents/invoices" v-else>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-credit-card</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>支払方法更新</v-list-item-title>
                </v-list-item>
            </template>
                        
            <hr>
            <v-list-item link href="/documents/contract-destination-companies" v-if="path.match('/contract-destination-companies')" class="act">
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-office-building-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>契約先企業一覧</v-list-item-title>
            </v-list-item>
            <v-list-item link href="/documents/contract-destination-companies" v-else>
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-office-building-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>契約先企業一覧</v-list-item-title>
            </v-list-item>

            <v-list-item link href="/documents/contract-destination-members" v-if="path.match('/contract-destination-members')" class="act">
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-account-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title style="font-size: 72%;">契約先メンバー一覧</v-list-item-title>
            </v-list-item>
            <v-list-item link href="/documents/contract-destination-members" v-else>
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-account-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title style="font-size: 72%;">契約先メンバー一覧</v-list-item-title>
            </v-list-item>
            <hr>

            <template v-if="navi.plan == true"> <!-- 有料プランのみ -->
                <v-list-item link href="/documents/organizations" v-if="path.match('/organizations') || path.match('/organization-users')" class="act">
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>グループ一覧</v-list-item-title>
                </v-list-item>
                <v-list-item link href="/documents/organizations" v-else>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>グループ一覧</v-list-item-title>
                </v-list-item>
            </template>

            <v-list-item link href="/documents/users" v-if="path.match('/users')" class="act">
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-title>メンバー一覧</v-list-item-title>
            </v-list-item>
            <v-list-item link href="/documents/users" v-else>
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-title>メンバー一覧</v-list-item-title>
            </v-list-item>
            <hr>

            <v-list-item link href="/documents/individual-electronic-imprints" v-if="path.match('/individual-electronic-imprints')" class="act">
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-stamper</v-icon>
                </v-list-item-icon>
                <v-list-item-title>個人用印影一覧</v-list-item-title>
            </v-list-item>
            <v-list-item link href="/documents/individual-electronic-imprints" v-else>
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-stamper</v-icon>
                </v-list-item-icon>
                <v-list-item-title>個人用印影一覧</v-list-item-title>
            </v-list-item>

            <template v-if="navi.plan == true"> <!-- 有料プラン -->
                <v-list-item link href="/documents/company-electronic-imprints" v-if="path.match('/company-electronic-imprints')" class="act">
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-stamper</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>企業用印影一覧</v-list-item-title>
                </v-list-item>
                <v-list-item link href="/documents/company-electronic-imprints" v-else>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-stamper</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>企業用印影一覧</v-list-item-title>
                </v-list-item>
            </template>

            <hr>
            <!--<v-list-item link href="/documents/security" v-if="path.match('/security')" class="act">-->
            <!--    <v-list-item-icon class="nav-icon">-->
            <!--        <v-icon>mdi-lock-outline</v-icon>-->
            <!--    </v-list-item-icon>-->
            <!--    <v-list-item-title>セキュリティ</v-list-item-title>-->
            <!--</v-list-item>-->
            <!--<v-list-item link href="/documents/security" v-else>-->
            <!--    <v-list-item-icon class="nav-icon">-->
            <!--        <v-icon>mdi-lock-outline</v-icon>-->
            <!--    </v-list-item-icon>-->
            <!--    <v-list-item-title>セキュリティ</v-list-item-title>-->
            <!--</v-list-item>-->
            <template v-if="navi.plan == true && user.role == 1"> <!-- 有料プランかつ管理者 -->
                <v-list-item link href="/documents/bills" v-if="path.match('/bills')" class="act">
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-currency-jpy</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>ご利用料金の確認</v-list-item-title>
                </v-list-item>
                <v-list-item link href="/documents/bills" v-else>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-currency-jpy</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>ご利用料金の確認</v-list-item-title>
                </v-list-item>
            </template>

            <template v-if="navi.plan == true && user.role == 1"> <!-- 有料プランかつ管理者 -->
                <v-list-item link href="/documents/usage-logs" v-if="path.match('/usage-logs')" class="act">
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-math-log</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>操作ログ</v-list-item-title>
                </v-list-item>
                <v-list-item link href="/documents/usage-logs" v-else>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-math-log</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>操作ログ</v-list-item-title>
                </v-list-item>
            </template>

            <template v-if="navi.plan == true && user.role == 1"> <!-- 有料プランかつ管理者 -->
                <v-list-item link href="/documents/signature-validation" v-if="path.match('/signature-validation')" class="act">
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-magnify</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>一括検証</v-list-item-title>
                </v-list-item>
                <v-list-item link href="/documents/signature-validation" v-else>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-magnify</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>一括検証</v-list-item-title>
                </v-list-item>
            </template>

            <template v-if="navi.plan == true && user.role == 1"> <!-- 有料プランかつ管理者 -->
                <v-list-item link href="/documents/access-limit" v-if="path.match('/access-limit')" class="act">
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-lock-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>アクセス制限</v-list-item-title>
                </v-list-item>
                <v-list-item link href="/documents/access-limit" v-else>
                    <v-list-item-icon class="nav-icon">
                        <v-icon>mdi-lock-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>アクセス制限</v-list-item-title>
                </v-list-item>
            </template>

            <v-list-item link href="/documents/notifications" v-if="path.match('/notifications')" class="act">
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-information-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>お知らせ一覧</v-list-item-title>
            </v-list-item>
            <v-list-item link href="/documents/notifications" v-else>
                <v-list-item-icon class="nav-icon">
                    <v-icon>mdi-information-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>お知らせ一覧</v-list-item-title>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
    export default {
        props: {
            user: Object,
            navi: [],
            path: String,
        }
    };
</script>
<style scoped>
    .nav-icon {
        margin-right: 10px !important;
    }
    .act {
        background-color: #e8e8e8;
    }
    hr {
        margin-bottom: 4px;
    }
    .v-expansion-panel:before {
        content: none !important;
    }
    .v-expansion-panel-header {
        padding: 0;
    }
    .v-expansion-panel--active>.v-expansion-panel-header {
        min-height: 48px;
    }
    .alert {
        color: red;
        font-size: 1.5rem !important;
    }
</style>